(ns metabase.util.namespaces
  (:require-macros
   [metabase.util.namespaces]))
